//PartyDetailAPI.js

import axiosInstance from "../BaseURL/axiosInstance";
import API_BASE_URL from "../BaseURL/baseURL";

export const fetchPartySignUpDetails = async (email) => {
  const response = await fetch(
    `${API_BASE_URL}/PartyDetails/GetPartySignUpDetails?email=${email}`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
  console.log(response.json());
};

export const fetchRelationData = async () => {
  const response = await fetch(`${API_BASE_URL}/PartyDetails/Get_Relation`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchOccupationData = async () => {
  const response = await fetch(`${API_BASE_URL}/PartyDetails/Get_Occupation`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchIDTypeData = async () => {
  const response = await fetch(`${API_BASE_URL}/PartyDetails/Get_IDType`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchGender = async () => {
  //debugger;
  const response = await fetch(`${API_BASE_URL}/PartyDetails/Get_GENDER`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const InsertPartyDetails = async (partyDetails) => {
  //debugger;
  const response = await fetch(
    `${API_BASE_URL}/PartyDetails/SavePartyDetails`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(partyDetails),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to insert Party Details");
  }
  return await response.json();
};

// export const InsertPartyDetailsPaperLess = async (partyDetails) => {
//   //debugger;
//   const response = await fetch(
//     `${API_BASE_URL}/PartyDetails/SavePartyDetails_paperless`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(partyDetails),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert Party Details");
//   }
//   return await response.json();
// };

export const InsertPartyDetailsPaperLess = async (partyDetails) => {
  try {
    const response = await axiosInstance.post(
      "/PartyDetails/SavePartyDetails_paperless",
      partyDetails
    );
    return response.data;
  } catch (error) {
    console.error("Insert PartyDetails Error:", error);
    throw new Error("Failed to insert Party Details (Paperless)");
  }
};

export const ModifyPartyDetails = async (partyDetails) => {
  //debugger;
  const response = await fetch(
    `${API_BASE_URL}/PartyDetails/UpdatePartyDetails`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(partyDetails),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to Modify Party Details");
  }
  return await response.json();
};

export const ModifyPartyDetailsPaperless = async (partyDetails) => {
  //debugger;

  try {
    const response = await axiosInstance.put(
      "/PartyDetails/UpdatePartyDetails_paperless",
      partyDetails
    );
    return response.data;
  } catch (error) {
    console.error("Update PartyDetails Error:", error);
    throw new Error("Failed to update Party Details (Paperless)");
  }
};
